import { useStore } from './store';

// Mirror console.log('[rtc] ...') / console.log('[call] ...') to /api/debug/log
// so we can watch both peers' logs server-side during the WebRTC debug session.
const orig = console.log.bind(console);
console.log = (...args: unknown[]): void => {
  orig(...args);
  const first = args[0];
  if (typeof first !== 'string') return;
  const m = first.match(/^\[(rtc|call)\](.*)$/);
  if (!m) return;
  const tag = `[${m[1]}]`;
  const rest = [m[2].trim(), ...args.slice(1)].map(fmt).filter(Boolean).join(' ');
  const token = useStore.getState().accessToken;
  if (!token) return;
  try {
    void fetch('/api/debug/log', {
      method: 'POST',
      headers: { 'content-type': 'application/json', authorization: `Bearer ${token}` },
      body: JSON.stringify({ tag, msg: rest }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
};

function fmt(a: unknown): string {
  if (typeof a === 'string') return a;
  if (a instanceof Error) return `${a.name}:${a.message}`;
  try {
    return JSON.stringify(a);
  } catch {
    return String(a);
  }
}
